import _u from './util';
import _v from './vars';
import _f from './func';

function shareCloseAndUnbind() {
	document.removeEventListener('click', shareClickAway);
	document.querySelectorAll('.pers-feed-item').forEach(function (element) {
		element.removeEventListener('click', shareClickAway);
	});
	document.querySelectorAll('[data-track-orig]').forEach(function (element) {
		if (element.getAttribute('data-track-orig') != null) {
			element.setAttribute('data-track', element.getAttribute('data-track-orig'));			
		}
		element.removeAttribute("data-track-orig");
	});	
	_f.closeShare();
}

function shareClickAway(e) {
	e.preventDefault();
	e.stopPropagation();
	if (_u.getClosest(e.target, '.share-layer') == null) {
		shareCloseAndUnbind();
	}
}

function shareLinkClick(e) {
	e.preventDefault();
	e.stopPropagation();
	if (this.classList.contains('cme-share')) {	
		let shareElem = this;
		if (shareElem.classList.contains('active')) {
			shareCloseAndUnbind();
		}
		else {
			shareCloseAndUnbind();
			shareElem.classList.add('active');
			shareElem.classList.add('shared');
			document.addEventListener('click', shareClickAway);
			document.querySelectorAll('.pers-feed-item').forEach(function (element) {
				element.addEventListener('click', shareClickAway);
			});			
			let parentCard = _u.getClosest(this, '.cme-card-container');
			_v.cmeShareElem = parentCard;
			let cmeShareLayer = _u.qS('.cme-share-layer');
			let scrollLeftValue = document.querySelector('.cme-glider-slide-container') == null && document.querySelector('.cme-generic-container') != null ? document.querySelector('.cme-generic-container').scrollLeft :  document.querySelector('.cme-glider-slide-container').scrollLeft;
			let leftPxCalc = ((parentCard.offsetLeft + this.offsetLeft + (this.offsetWidth/2)) - scrollLeftValue);

			if (_v.cmeGliderInst != null && _v.cmeGliderInst.itemWidth == 330) { // If BP1
				leftPxCalc = ((this.parentNode.offsetLeft + this.offsetLeft + (this.offsetWidth/2)) - (_v.cmeGliderInst.slide * 330) - 15); // -15 for full-width carousel negative-margin workaround
			}
			if (leftPxCalc < parentCard.offsetWidth) {
				cmeShareLayer.classList.add('leftmost');
			} else {
				cmeShareLayer.classList.remove('leftmost');
			}
			// only when ther are 2 cards in CME bucket
			if (parentCard.classList.contains('double-cards')) {
				leftPxCalc = leftPxCalc + 100;
			}
			cmeShareLayer.style.left = leftPxCalc + 'px';
			cmeShareLayer.classList.add('active');
			wmdPageLink('fy-cmecont_share', parentCard);
		}
	}
	else {
		let parentCard = _u.getClosest(this, '.pers-feed-item');
		let shareElem = this.parentNode;
		if (shareElem.classList.contains('active')) {
			shareCloseAndUnbind();
		}
		else {
			shareCloseAndUnbind();
			shareElem.classList.add('active');
			shareElem.classList.add('shared');
			document.addEventListener('click', shareClickAway);
			document.querySelectorAll('.pers-feed-item').forEach(function (element) {
				element.addEventListener('click', shareClickAway);
			});
			wmdPageLink('fy-cont_share', parentCard);
		}
	}
}

function socialIconClick(e) {
	e.preventDefault();
	e.stopPropagation();
	let parentCard = _u.getClosest(this, '.pers-feed-item, .pers-article-item, .cme-glider-container');
	if (this.parentNode.classList.contains('cme-share-layer')) {
		parentCard = _v.cmeShareElem;
	}
	parentCard.setAttribute('data-track-orig', parentCard.getAttribute('data-track'));
	
	if (this.classList.contains("facebook")) {
		parentCard.setAttribute('data-track', 'fy-share_face');
		fburl(parentCard);
	} else if (this.classList.contains("twitter")) {
		parentCard.setAttribute('data-track', 'fy-share_twit');
		twiturl(parentCard);
	} else if (this.classList.contains("linkedin")) {
		parentCard.setAttribute('data-track', 'fy-share_link');
		linkedinurl(parentCard);
	} else if (this.classList.contains("whatsapp")) {
		parentCard.setAttribute('data-track', 'fy-share_what');
		whatsappurl(parentCard);
	}
	
	shareCloseAndUnbind();

	let notificationElement = document.querySelector('.share-notification-container');
	notificationElement.classList.remove('hide');
	notificationElement.classList.add('active');
	setTimeout(function () {
		notificationElement.classList.remove('active');
		notificationElement.classList.add('hide');
	}, 5000);
}


function shareHandler() {
	document.querySelectorAll('.pers-share .pers-share-text').forEach(element => {
		element.removeEventListener('click', shareLinkClick);
		element.addEventListener('click', shareLinkClick);
	});
	document.querySelectorAll('.pers-share.cme-share').forEach(element => {
		element.removeEventListener('click', shareLinkClick);
		element.addEventListener('click', shareLinkClick);
	});
	document.querySelectorAll('.share-icon').forEach(element => {
		element.removeEventListener('click', socialIconClick);
		element.addEventListener('click', socialIconClick);
	});
	document.querySelector('.share-cancel-icon').addEventListener('click', function() {
		document.querySelector('.share-notification-container').classList.remove('active');
		document.querySelector('.share-notification-container').classList.add('hide');
	});
}

// Preload Share animation frames
_u.preLoadImg(['/pi/features/mymedscape/icons/Share/Share-off.svg', '/pi/features/mymedscape/icons/Share/Share-hover.svg', '/pi/features/mymedscape/icons/Share/Share-on.svg']);

document.addEventListener(_v.initialLoadEvent, function() {
	shareHandler();
	document.removeEventListener('feedLoaded', shareHandler);
	document.addEventListener('feedLoaded', shareHandler);
});